import { render, staticRenderFns } from "./modificaPratica.vue?vue&type=template&id=205f6f95&scoped=true&"
import script from "./modificaPratica.vue.ts?vue&type=script&lang=ts&"
export * from "./modificaPratica.vue.ts?vue&type=script&lang=ts&"
import style0 from "./modificaPratica.vue?vue&type=style&index=0&id=205f6f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f6f95",
  null
  
)

export default component.exports